<template>
  <div>
    <div class="is-flex-centered is-flex-direction-column custom-width">
      <h1 class="is-size-1 has-text-weight-bold m-b-30">{{ $t('estate.take-the-quiz') }}</h1>
      <p class="is-size-3 m-b-30">{{ $t('estate.determine-the-best') }}</p>
      <FormMultiSelect
        class="is-full-width"
        v-model="jurisdictionId"
        :config="jurisdictionSelectConfig"
        :query-params="queryParams"
        :rules="{ required: true }"
        :data-e2e="EstateCypressAttribute.onboarding.inputs.JURISDICTION"
      />
      <LightDiagnostic :show-billing-plan="true" :jurisdiction-id="jurisdictionId" />
    </div>
  </div>
</template>

<script>
import LightDiagnostic from '@/modules/lightdiagnostic/components/stateful/LightDiagnostic.vue';
import FormMultiSelect from '@/modules/core/form/components/FormMultiSelect.vue';
import { JurisdictionSelectConfig } from '@/modules/predefined/models/JurisdictionSelectConfig';
import { PredefinedCountry } from '@/modules/predefined/enums/PredefinedCountry';
import { EstateCypressAttribute } from '@/modules/estate/constants/EstateCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'LightDiagnosticLandingView',
  components: { FormMultiSelect, LightDiagnostic },
  static: {
    EstateCypressAttribute
  },
  local() {
    return {
      jurisdictionSelectConfig: new JurisdictionSelectConfig({
        trackBy: 'id',
        placeholder: this.$t('contact.state')
      })
    };
  },
  data() {
    return {
      jurisdictionId: null
    };
  },
  computed: {
    queryParams() {
      return { countryId: PredefinedCountry.CANADA.id };
    }
  }
};
</script>

<style scoped>
@media (min-width: 1024px) {
  .custom-width {
    width: 70%;
    margin: auto;
  }
}

@media (max-width: 1215px) {
  .custom-width {
    width: 80%;
    margin: auto;
  }
}

@media (max-width: 768px) {
  .custom-width {
    width: 100%;
    margin: auto;
  }
}
</style>
